<template>
  <div :class="{ 'mt-30-px': !showNavbar }">
    <notifications></notifications>

    <navbar v-if="showNavbar"
            :docsName="docsName"
    />

    <ValidationObserver v-slot="{ invalid }">
      <div class="container-fluid row">
        <div v-if="showNavbar" class="col-xl-12">
          <div class="row">
            <div class="col-xl-12 block br-t-l-0 mb-3">
              <head-menu
                :col="12"
                class="d-xl-flex"
                :headline="
                  $t('global.informationevent') +
                  (infoanlass.bezeichnung ? ': ' + infoanlass.bezeichnung : '')
                "
              ></head-menu>
              <div class="row mt-2 d-flex justify-content-between">
                <div class="ml-4">
                  <button
                    v-if="editable"
                    v-shortkey.once="['ctrl', 's']"
                    class="btn btn-success mr-2"
                    :disabled="invalid"
                    @click="speichern"
                    @shortkey="speichern"
                  >
                    {{ $t("global.save") }}
                  </button>
                  <button class="btn btn-primary mr-2" @click="abbrechen">
                    <font-awesome-icon icon="fa-solid fa-list" class="mr-2" />{{
                      $t("global.tolist")
                    }}
                  </button>
                </div>
                <div class="mr-4">
                  <button
                    class="btn btn-danger"
                    @click="oeffneLoeschenModal"
                    v-if="berechtigungen.m_bildung.delete"
                  >
                    <font-awesome-icon
                      class="mr-1"
                      icon="fa-duotone fa-trash"
                    />
                    <span>{{ $t("global.delete") }}</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-xl-6 pr-4" :class="{ 'col-xl-12': !showNavbar }">
          <generisch-stammdaten
            :v-if="infoanlassid"
            :veranstaltung="infoanlass"
            :editable="editable"
            :isTemplate="false"
            :veranstaltungstypen="infoanlasstypen"
          />

          <generisch-teilnehmer
            :v-if="infoanlassid"
            :veranstaltung="infoanlass"
            :editable="editable"
            :isTemplate="false"
          />
        </div>

        <div class="col-xl-6 pl-4" :class="{ 'col-xl-12': !showNavbar }">
          <infoanlass-details
            :v-if="infoanlassid"
            :infoanlass="infoanlass"
            :editable="editable"
            :isTemplate="false"
          />
        </div>

        <!-- ENDE Rechte Seite -->
        <div v-if="infoanlassid" class="col-xl-12">
          <div class="row">
            <div class="col-xl-12 p-0">
              <ul class="nav nav-tabs mt-3 fs-28">
                <li class="nav-item">
                  <router-link
                    class="primary-headline-text nav-link"
                    :class="{ active: anzeige === 0 }"
                    :to="{
                      name: 'infoanlass',
                      params: { infoanlassid: infoanlassid, anzeige: 0 },
                    }"
                    >{{ $t("global.registrations") }}</router-link
                  >
                </li>

                <li class="nav-item">
                  <router-link
                    class="primary-headline-text nav-link"
                    :class="{ active: anzeige === 1 }"
                    :to="{
                      name: 'infoanlass',
                      params: { infoanlassid: infoanlassid, anzeige: 1 },
                    }"
                    >{{ $t("global.lecturerbooking") }}</router-link
                  >
                </li>

                <li class="nav-item">
                  <router-link
                    class="primary-headline-text nav-link"
                    :class="{ active: anzeige === 2 }"
                    :to="{
                      name: 'infoanlass',
                      params: { infoanlassid: infoanlassid, anzeige: 2 },
                    }"
                    >{{ $t("global.appointment") }}</router-link
                  >
                </li>

                <li class="nav-item">
                  <router-link
                    class="primary-headline-text nav-link"
                    :class="{ active: anzeige === 3 }"
                    :to="{
                      name: 'infoanlass',
                      params: { infoanlassid: infoanlassid, anzeige: 3 },
                    }"
                    >{{ $t("global.clearingitems") }}</router-link
                  >
                </li>
              </ul>
            </div>
            <div class="col-xl-12 p-0">
              <div class="tab-container p-3">
                <div v-show="anzeige === 0">
                  <anmeldungsliste
                    :veranstaltung="infoanlassid"
                    :shown="anzeige == 0 ? true : false"
                    :editable="editable"
                    :key="anmeldungslisteKey"
                    :showUebertragen="false"
                  />
                </div>

                <div v-show="anzeige === 1">
                  <dozentenbuchungsliste
                    :veranstaltung="infoanlassid"
                    :shown="anzeige == 1 ? true : false"
                    :editable="editable"
                  />
                </div>
                <div v-show="anzeige === 2">
                  <terminliste
                    :veranstaltung="infoanlassid"
                    :shown="anzeige == 2 ? true : false"
                    :editable="editable"
                  />
                </div>

                <div v-show="anzeige === 3">
                  <verrechnungspositionen
                    :veranstaltung="infoanlassid"
                    :shown="anzeige == 3 ? true : false"
                    :editable="editable"
                    @positionChanged="anmeldungslisteUpdate"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ValidationObserver>

    <loading-overlay v-show="loading"></loading-overlay>

    <change-watcher-alert />

    <messagebox-enhanced
      :headerText="$t('global.startpromotion')"
      :ok="true"
      @ok="promotionStart"
    />
    <loeschen-modal
      id="infoanlass-loeschen-modal"
      @confirmed="infoanlassloeschen"
    />
  </div>
</template>

<script>
import Api from "@/Api";
import page from "@/mixins/Page";
import ChangeWatcher from "@/mixins/ChangeWatcher";

import HeadMenu from "@/components/HeadMenu";
import Navbar from "@/components/Navbar";

import { apiErrorToAlert } from "@/utils/Errorhandler";

import GenerischStammdaten from "@/components/Bildung/Generisch/Stammdaten";
import GenerischTeilnehmer from "@/components/Bildung/Generisch/Teilnehmer";
import InfoanlassDetails from "@/components/Bildung/Infoanlass/InfoanlassDetails.vue";

import Anmeldungsliste from "@/components/Reiter/Anmeldungsliste";
import Terminliste from "@/components/Reiter/Terminliste";
import Dozentenbuchungsliste from "@/components/Reiter/Dozentenbuchungsliste";
import Verrechnungspositionen from "@/components/Reiter/Verrechnungspositionen.vue";

import LoeschenModal from "@/components/Modals/LoeschenModal";

import MessageboxEnhanced from "@/components/Modals/MessageboxEnhanced.vue";

export default {
  name: "infoanlass",
  components: {
    HeadMenu,
    Navbar,
    LoeschenModal,
    GenerischStammdaten,
    GenerischTeilnehmer,
    InfoanlassDetails,
    Anmeldungsliste,
    MessageboxEnhanced,
    Terminliste,
    Dozentenbuchungsliste,
    Verrechnungspositionen,
  },
  metaInfo() {},
  mixins: [page, ChangeWatcher],

  props: {
    infoanlassid: {
      type: String,
      default: null,
    },
    anzeige: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      anmeldungslisteKey: 0,
      infoanlass: {
        lehrgang: {
          bezeichnung: this.$t("global.notlinked"),
          lehrgangstatus: { bezeichnung: this.$t("global.notlinked") },
        },
        verantwortlicher: { personName: this.$t("global.notlinked") },
      },
    };
  },
  computed: {
    infoanlasstypen: function () {
      let infoanlasstypen = [];
      infoanlasstypen.push({
        bezeichnung: "Informationsanlass",
        id: "174D91487E6",
      });
      return infoanlasstypen;
    },
  },
  watch: {
    infoanlassid: {
      handler: function (val) {
        if (val) {
          this.ladeVeranstaltung(val);
        } else {
          this.editable = this.berechtigungen.m_bildung.update;
        }
      },
      immediate: true,
    },
  },
  created() {},
  mounted: function () {},
  methods: {
    ladeVeranstaltung(infoanlassid) {
      this.loading = true;

      Api.get("veranstaltungen/", { params: { id: infoanlassid } })
        .then((response) => {
          this.initializeinfoanlass(response.data);
        })
        .finally(() => {
          this.loading = false;
        });
    },

    initializeinfoanlass(infoanlass) {
      if (infoanlass) {
        this.infoanlass = infoanlass;

        if (!this.infoanlass.verantwortlicher)
          this.infoanlass.verantwortlicher = {
            personName: this.$t("global.notlinked"),
          };

        if (!this.infoanlass.lehrgang)
          this.infoanlass.lehrgang = {
            bezeichnung: this.$t("global.notlinked"),
            lehrgangstatus: { bezeichnung: this.$t("global.notlinked") },
          };

        if (!this.infoanlass.lehrgang.lehrgangstatus)
          // Datenfail in der Datenbank Lehrgang ohne Status
          this.infoanlass.lehrgang.lehrgangstatus = {
            bezeichnung: this.$t("global.notlinked"),
          };

        this.editable = this.$CONST("EVENTEDITABLESTATI").includes(
          this.infoanlass.veranstaltungsstatus.id
        )
          ? true
          : false;
      } else {
        console.error("infoanlass ist null");
      }

      this.initChangeWatcher(this.infoanlass);

      this.editable = !this.berechtigungen.m_bildung.update
        ? false
        : this.editable;
    },

    promotion() {
      this.$bus.$emit("openMessageBoxEnhanced", {
        text: this.$t("global.shouldthepromotionbestarted"),
      });
    },

    promotionStart() {
      Api.put(
        "noten/promotion",
        {},
        {
          params: { infoanlass: this.infoanlass.id },
        }
      ).then(() => {});
    },

    abbrechen() {
      this.$router.push({ name: "infoanlass-liste" });
    },

    speichern() {
      if (this.loading) return;

      this.loading = true;

      var json = Object.assign({}, this.infoanlass);

      if (this.infoanlass.qualifikationen)
        json.qualifikationen = this.infoanlass.qualifikationen.map((qa) => {
          return qa.id;
        });

      if (this.infoanlass.themen)
        json.themen = this.infoanlass.themen.map((t) => {
          return t.id;
        });

      json.lehrgang = this.infoanlass.lehrgang?.id;
      json.veranstaltungsstatus = this.infoanlass.veranstaltungsstatus?.id;
      json.veranstaltungstyp = this.$CONST("VERANSTALTUNGSTYPEN").INFO;
      json.verantwortlicher = this.infoanlass.verantwortlicher?.id;
      json.periode = this.infoanlass.periode?.id;

      if (!this.infoanlassid) {
        Api.post("veranstaltungen/", json)
          .then((response) => {
            this.$notify({
              type: "success",
              title: this.$t("global.actionsuccessful"),
              text: this.$t("global.coursesuccessfullysaved"),
            });
            this.$router.replace({
              name: "infoanlass",
              params: { infoanlassid: response.data.id, anzeige: 0 },
            });
          })
          .catch((e) => {
            this.$notify(apiErrorToAlert(e));
          })
          .finally(() => {
            this.loading = false;
          });
      } else {
        Api.put("veranstaltungen/", json, {
          params: { id: this.infoanlass.id },
        })
          .then((response) => {
            this.initializeinfoanlass(response.data);
            this.$notify({
              type: "success",
              title: this.$t("global.actionsuccessful"),
              text: this.$t("global.coursesuccessfullysaved"),
            });
          })
          .catch((e) => {
            this.$notify(apiErrorToAlert(e));
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },
    oeffneLoeschenModal() {
      this.$bus.$emit("openLoeschenModal", "infoanlass-loeschen-modal");
    },
    anmeldungslisteUpdate() {
      this.anmeldungslisteKey++;
    },
    infoanlassloeschen() {
      let selectedId = [this.infoanlassid];
      Api.delete("veranstaltungen/", {
        params: { ids: selectedId.join(",") },
      }).then(() => {
        this.$router.replace({ name: "infoanlass-liste" });
      });
    },
  },
};
</script>

<style></style>
